"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextService = void 0;
const p_queue_1 = __importDefault(require("p-queue"));
const Logger_1 = __importDefault(require("./Logger"));
const Utils = __importStar(require("./Utils"));
const UrlUtils_1 = require("./UrlUtils");
const Common_1 = require("./Common");
const Fingerprint_1 = require("./Fingerprint");
class ContextService {
    constructor() {
        this.taskQueue = new p_queue_1.default({ concurrency: 1 });
        this.fingerprint = new Fingerprint_1.Fingerprint();
        this.context = {
            facets: {},
            config: {
                debug: false,
                env: Common_1.DEFAULT_ENV,
                facetBasedFiltering: false,
                hostProductData: false,
                sendEvent: true,
                sessionDuration: { hour: 1 },
                sessionId: null,
                captureDocumentClickEvents: false,
                disableAutoPageCapture: false,
                captureDocumentScrollEvents: false,
                documentScrollSessionDuration: Common_1.DEFAULT_SCROLL_DEBOUNCE_DURATION,
            },
            callback: {
                eventHooks: {},
                customFacets: {},
            },
        };
    }
    get user() {
        return this.context.user;
    }
    readUserConsentPreferences() {
        return this.context.userConsentPreferences;
    }
    readUserConsentCopy() {
        return this.context.userConsentCopy;
    }
    writeUserConsentPreferences(preferences) {
        this.context.userConsentPreferences = preferences;
    }
    writeUserConsentCopy(userConsentCopy) {
        this.context.userConsentCopy = userConsentCopy;
    }
    get tracker() {
        return this._tracker;
    }
    set tracker(value) {
        this._tracker = value;
    }
    set session(value) {
        if (this.context) {
            this.context.session_id = value;
        }
    }
    getPageFacet(base) {
        var _a, _b;
        const delimiter = /\s*,\s*/;
        const keywords = ((_b = (_a = document
            .querySelector('meta[name="keywords"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) === null || _b === void 0 ? void 0 : _b.trim().split(delimiter).filter((keyword) => !!keyword)) || [];
        const facet = Object.assign({}, (0, UrlUtils_1.detectPage)(document.location.href, document.referrer));
        if (document.title) {
            facet.title = document.title;
        }
        if (document.referrer) {
            facet.referrer = document.referrer;
        }
        if (keywords.length > 0) {
            facet.keywords = keywords;
        }
        return Object.assign(Object.assign(Object.assign({}, base), facet), { properties: Object.assign(Object.assign({}, base === null || base === void 0 ? void 0 : base.properties), facet.properties) });
    }
    setup(product) {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.setLevel(this.context.config.debug ? "DEBUG" : "ERROR");
            Logger_1.default.debug("BEGIN Setup Context", { SDK_VERSION: Common_1.SDK_VERSION, SCHEMA_VERSION: Common_1.SCHEMA_VERSION }, this.context);
            this.setupProduct(product);
            if (this.context.device_id == null) {
                this.context.device_id = this.fingerprint.fingerprint();
            }
            this.context.facets = Utils.buildFacets(this.context.facets);
            Logger_1.default.debug("END Setup Context", this.context);
        });
    }
    setupProduct(product) {
        if (!(product === null || product === void 0 ? void 0 : product.id)) {
            Logger_1.default.warn("You need to specify the product facet with the product id to instantiate the tracker");
        }
        if (!this.isValidProduct(product)) {
            Logger_1.default.warn("The product facet should be specified with the id, name & id_provider to instantiate the tracker");
        }
        if (!this.isValidProductIdProvider(product === null || product === void 0 ? void 0 : product.id_provider)) {
            Logger_1.default.warn("The provider id_provider is not a valid one");
        }
        this.context.facets.product = product;
        this.context.facets.product.meta = Object.assign(Object.assign({}, this.context.facets.product.meta), (0, UrlUtils_1.detectProductReferral)(window.location.href));
    }
    isValidProduct(product) {
        return product ? !(!product.id || !product.name || !product.id_provider) : false;
    }
    isValidProductIdProvider(provider) {
        const upper = String(provider).toLocaleLowerCase();
        return upper === "appkey" || upper === "upi1" || upper === "upi2";
    }
    sendEventInQueue(eventType, facets, consentMetric) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._tracker.sendEventInQueue(eventType, facets, consentMetric);
        });
    }
    /**
     * Dispatches the specified hooks
     * @param type Hook type
     * @param action Payload descriptor for the hook
     */
    dispatch(type, action) {
        var _a;
        (_a = this.context.callback.eventHooks[type]) === null || _a === void 0 ? void 0 : _a.forEach((callback) => {
            callback(this.context, action === null || action === void 0 ? void 0 : action.message);
        });
    }
}
exports.ContextService = ContextService;
